/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
.li {
  list-style-type: none;
  white-space: nowrap;
  padding-inline: calc(var(--spacing, 0.25rem) * 4);
  padding-block: calc(var(--spacing, 0.25rem) * 2);
  color: var(--color-emphasis-medium, #525252);
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
}
